import React from "react"
import { FaCircleExclamation } from "react-icons/fa6"

function NurseBreak({ formData, setFormData, errors, hasWriteSettingsPermission }) {
	if (hasWriteSettingsPermission) {
		// Editable version
		return (
			<div>
				<h2 className="text-2xl font-semibold text-gray-900 mb-4">Nurse Break Info</h2>

				{/* Lunch Break Duration */}
				<div className="col-span-2 sm:col-span-2 mb-6">
					<label
						htmlFor="break_duration"
						className="block text-sm font-medium text-gray-700"
					>
						Lunch Break Duration
					</label>
					<div className="relative mt-2 rounded-md shadow-sm">
						<input
							type="number"
							value={formData?.break_duration || ""}
							onChange={e =>
								setFormData(prev => ({
									...prev,
									break_duration: e.target.value
								}))
							}
							className={`block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
								errors.break_duration
									? "text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-red-500"
									: "ring-1 ring-inset ring-gray-300 focus:ring-indigo-500"
							}`}
							placeholder="Suggested Break Duration"
							aria-invalid={errors.break_duration ? "true" : "false"}
						/>
						{errors.break_duration && (
							<div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center">
								<FaCircleExclamation
									aria-hidden="true"
									className="h-5 w-5 text-red-500"
								/>
							</div>
						)}
					</div>
					{errors.break_duration && (
						<p id="break_duration-error" className="text-red-500 text-sm mt-1">
							{errors.break_duration}
						</p>
					)}
				</div>

				{/* Lunch Break - Start Time */}
				<div className="col-span-1 sm:col-span-1 mb-6">
					<label
						htmlFor="break_start_time"
						className="block text-sm font-medium text-gray-700"
					>
						Earliest Lunch Start Time
					</label>
					<div className="relative mt-2 rounded-md shadow-sm">
						<input
							type="time"
							value={formData?.break_start_time || ""}
							onChange={e =>
								setFormData(prev => ({
									...prev,
									break_start_time: e.target.value
								}))
							}
							className={`block w-full rounded-md border-0 py-1.5 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
								errors.break_start_time
									? "pr-10 text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-red-500"
									: "ring-1 ring-inset ring-gray-300 focus:ring-indigo-500"
							}`}
							aria-invalid={errors.break_start_time ? "true" : "false"}
							placeholder="Lunch Break - Start Time"
						/>
						{errors.break_start_time && (
							<div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center">
								<FaCircleExclamation
									aria-hidden="true"
									className="h-5 w-5 text-red-500"
								/>
							</div>
						)}
					</div>
					{errors.break_start_time && (
						<p id="break_start_time-error" className="mt-2 text-sm text-red-600">
							{errors.break_start_time}
						</p>
					)}
				</div>

				{/* Lunch Break - End Time */}
				<div className="col-span-1 sm:col-span-1 mb-6">
					<label
						htmlFor="break_end_time"
						className="block text-sm font-medium text-gray-700"
					>
						Latest Lunch End Time
					</label>
					<div className="relative mt-2 rounded-md shadow-sm">
						<input
							type="time"
							value={formData?.break_end_time || ""}
							onChange={e =>
								setFormData(prev => ({
									...prev,
									break_end_time: e.target.value
								}))
							}
							className={`block w-full rounded-md border-0 py-1.5 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${
								errors.break_end_time
									? "pr-10 text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-red-500"
									: "ring-1 ring-inset ring-gray-300 focus:ring-indigo-500"
							}`}
							aria-invalid={errors.break_end_time ? "true" : "false"}
							placeholder="Lunch Break - End Time"
						/>
						{errors.break_end_time && (
							<div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center">
								<FaCircleExclamation
									aria-hidden="true"
									className="h-5 w-5 text-red-500"
								/>
							</div>
						)}
					</div>
					{errors.break_end_time && (
						<p id="break_end_time-error" className="mt-2 text-sm text-red-600">
							{errors.break_end_time}
						</p>
					)}
				</div>
			</div>
		)
	} else {
		// Read-only version
		return (
			<div>
				<h2 className="text-2xl font-semibold text-gray-900 mb-4">Nurse Break Info</h2>
				<div className="col-span-2 sm:col-span-2 mb-6">
					<label className="block text-sm font-medium text-gray-700">
						Lunch Break Duration
					</label>
					<span className="block w-full rounded-md py-1.5 text-gray-900 sm:text-sm">
						{formData.break_duration || "N/A"} minutes
					</span>
				</div>
				<div className="col-span-1 sm:col-span-1 mb-6">
					<label className="block text-sm font-medium text-gray-700">
						Earliest Lunch Start Time
					</label>
					<span className="block w-full rounded-md py-1.5 text-gray-900 sm:text-sm">
						{formData.break_start_time || "N/A"}
					</span>
				</div>
				<div className="col-span-1 sm:col-span-1 mb-6">
					<label className="block text-sm font-medium text-gray-700">
						Latest Lunch End Time
					</label>
					<span className="block w-full rounded-md py-1.5 text-gray-900 sm:text-sm">
						{formData.break_end_time || "N/A"}
					</span>
				</div>
			</div>
		)
	}
}

export default NurseBreak
